import React from "react";
import baseStyles from "../../style.module.scss";
import styles from "./style.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import CheckGreenCircleIcon from "../../../../assets/svg/icons/common/check-green-circle";
import Select from "../../../../components/form/select";
import { useFormikContext } from "formik";
import { additionalAppInfoSchema } from "../../validation-schema";

function AdditionalAppInfo({ isOpen, onToggle, emsOfficeOptions }) {
  const { values, errors, handleBlur, setFieldValue } = useFormikContext();

  const isSectionValid = additionalAppInfoSchema.isValidSync(values) && values.ems_office_id;

  return (
    <div className={baseStyles.section}>
      <div className={baseStyles.sectionHeader} onClick={onToggle}>
        <div
          className={`${baseStyles.sectionHeaderLeft} ${isOpen && baseStyles.open}`}
        >
          <CaretDown24 />
          <h6 className={baseStyles.sectionTitle}>KURV Office Information</h6>
        </div>
        <div className={baseStyles.sectionHeaderRight}>
          {isSectionValid && <CheckGreenCircleIcon />}
        </div>
      </div>
      {isOpen && (
        <div className={`${styles.content} ${styles.form}`}>
          <div className={styles.form_group}>
            <Select
              label="KURV Office ID"
              name="ems_office_id"
              placeholder="Select KURV Office ID"
              search
              options={emsOfficeOptions}
              value={values.ems_office_id}
              onChange={(value) => {
                setFieldValue("ems_office_id", typeof value === "object" ? value.value : value);
              }}
              onBlur={handleBlur}
              error={errors.ems_office_id}
              touched={errors.ems_office_id}
              errored={errors.ems_office_id}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default AdditionalAppInfo;
